import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';

export type ArticleDeleteData = AnyObject;

export type ArticleDeleteResponse = ArticleDeleteData;

export interface ArticleDelete {
  id: string;
}

export const articleDelete = (payload: ArticleDelete): Action<ArticleDelete> => ({
  type: actions.articleDeleteTrigger.toString(),
  payload,
});

export const articleDeleteClear = (): Action => ({
  type: actions.articleDeleteClear.toString(),
});

export const articleDeleteErrorClear = (): Action => ({
  type: actions.articleDeleteErrorReset.toString(),
});

export function* articleDeleteRequestSaga({ payload }: Action<ArticleDelete>) {
  yield put({
    type: actions.articleDeleteStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.articleDeleteError.toString(),
      payload: {
        message: 'ArticleDelete: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/articles/${id}`,
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<ArticleDeleteData, ArticleDeleteResponse>(
    response,
    actions.articleDeleteSuccess.toString(),
    actions.articleDeleteError.toString(),
    false,
    (articleDeleteData) => articleDeleteData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.articleDeleteTrigger.toString(),
    defaultProcessingSaga(
      articleDeleteRequestSaga,
      {
        error: actions.articleDeleteError.toString(),
        locationCancel: actions.articleDeleteClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.articleDeleteSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.articleDeleteClear.toString(),
    // });
  });

  yield takeLatest(actions.articleDeleteError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.articleDeleteErrorReset.toString(),
    });
  });
}
